import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { BonificoOrderDTO, CalendarDate } from "./BonificoOrderDTO.ts";

export function useMarkBonificoOrderAsPaid() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const markAsPaid = async (
    orderId: string,
    valueDate: CalendarDate,
    amountInCents?: number,
  ): Promise<BonificoOrderDTO> => {
    setLoading(true);
    try {
      const { data } = await createAxiosInstance().post<BonificoOrderDTO>(
        `/bonifico-orders/${orderId}/mark-as-paid`,
        { valueDate, amountInCents },
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return { markAsPaid, loading };
}
